export function capitalize(s: string) {
    const splitStr = s.toLowerCase().split(" ")
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
    }
    return splitStr.join(" ")
}

export function pascalCase(s: string) {
    return s.charAt(0).toUpperCase() + s.substring(1, s.length)
}


// WEBPACK FOOTER //
// ./src/name-helpers/nameFormatter.ts